import React from 'react';
import { STATUS_LABELS, STATUS_STYLES, isPendingStatus } from './admissionText';

export default function StatusBadge({ status }) {
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-medium ${
        STATUS_STYLES[status] || 'bg-gray-100 text-gray-600'
      }`}
    >
      {isPendingStatus(status) && (
        <span className="h-1.5 w-1.5 rounded-full bg-current animate-pulse" />
      )}
      {STATUS_LABELS[status] || status}
    </span>
  );
}
